import { render } from "./MyBenefitSearch.vue?vue&type=template&id=9ea6d6be"
import script from "./MyBenefitSearch.vue?vue&type=script&lang=js"
export * from "./MyBenefitSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__